exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader-dots span[data-v-0cddf195]{display:inline-block;width:15px;height:15px;border-radius:9999px;background-color:#c2ddff}.loader-dots span[data-v-0cddf195]:first-child{animation:bounce-data-v-0cddf195 1s ease-in-out infinite}.loader-dots span[data-v-0cddf195]:nth-child(2){animation:bounce-data-v-0cddf195 1s ease-in-out .33s infinite}.loader-dots span[data-v-0cddf195]:nth-child(3){animation:bounce-data-v-0cddf195 1s ease-in-out .66s infinite}#loader-2.disabled span[data-v-0cddf195]{animation:none}@keyframes bounce-data-v-0cddf195{0%,75%,to{transform:translateY(0)}25%{transform:translateY(-20px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0cddf195","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/Synchro.vue
// module id = 696
// module chunks = 0